import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMoveSearchResultsQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  searchInputNumber: Types.Scalars['bigint']['input'];
  searchInputString: Types.Scalars['String']['input'];
  orderBy?: Types.InputMaybe<Array<Types.Moves_Order_By> | Types.Moves_Order_By>;
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
}>;


export type GetMoveSearchResultsQuery = { __typename?: 'query_root', moves: Array<{ __typename?: 'moves', id: number, active: number, cancel_reason?: string | null, cancel_requested_at?: string | null, cancel_status?: string | null, canceled_at?: string | null, chargeable: boolean, config?: object | null, consumer_at_pickup: number, consumer_name?: string | null, consumer_phone?: string | null, consumer_pickup?: boolean | null, consumer_type?: string | null, createdat?: string | null, createdBy?: string | null, customer_id?: number | null, deliver_by?: string | null, delivery_arrived?: string | null, delivery_started?: string | null, delivery_successful?: string | null, delivery_time?: string | null, driver_id?: number | null, driver_name?: string | null, lane_id?: number | null, lite: boolean, manual_flag: boolean, move_type: string, payer_id?: number | null, pickup_arrived?: string | null, pickup_started?: string | null, pickup_successful?: string | null, pickup_time?: string | null, ready_by?: string | null, reference_num?: string | null, status?: string | null, tags?: string | null, updatedat?: string | null, usecase_key?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, customer?: { __typename?: 'customers', id: number, name?: string | null } | null, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null } | null } | null, eventlogs: Array<{ __typename?: 'eventlogs', id: number, user: string }>, hangtags: Array<{ __typename?: 'hangtags', id: number, hash_id: string, rear_code?: string | null, status: string, type: string, updated_at?: string | null, workflow_data?: object | null }>, lane?: { __typename?: 'lanes', id: number, description?: string | null, distance_miles?: number | null, duration_sec?: number | null, pickup: { __typename?: 'locations', id: number, address?: string | null, name?: string | null }, delivery: { __typename?: 'locations', id: number, address?: string | null, name?: string | null } } | null, movesByReturnRideId: Array<{ __typename?: 'moves', id: number, consumer_at_pickup: number, consumer_name?: string | null, consumer_phone?: string | null, consumer_pickup?: boolean | null, consumer_type?: string | null }>, parentMove?: { __typename?: 'moves', id: number, lite: boolean, status?: string | null } | null, scenariotomoves: Array<{ __typename?: 'scenariotomoves', scenario: { __typename?: 'scenarios', id: number, bundletoscenarios: Array<{ __typename?: 'bundletoscenarios', bundle: { __typename?: 'bundles', id: number, offers: Array<{ __typename?: 'offers', id: number, status: string, driver: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', display_name: string, avatar_url?: string | null } | null } }> } }> } }>, workflowset?: { __typename?: 'workflowsets', id: number, name: string } | null }> };


export const GetMoveSearchResultsDocument = gql`
    query getMoveSearchResults($start: timestamptz!, $end: timestamptz!, $searchInputNumber: bigint!, $searchInputString: String!, $orderBy: [moves_order_by!], $limit: Int!, $offset: Int!) {
  moves(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, _and: [{_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}], _or: [{id: {_eq: $searchInputNumber}}, {consumer_name: {_ilike: $searchInputString}}, {consumer_phone: {_ilike: $searchInputString}}, {customer: {name: {_ilike: $searchInputString}}}, {lane: {description: {_ilike: $searchInputString}}}, {lane: {pickup: {name: {_ilike: $searchInputString}}}}, {lane: {delivery: {name: {_ilike: $searchInputString}}}}, {lane: {pickup: {address: {_ilike: $searchInputString}}}}, {lane: {delivery: {address: {_ilike: $searchInputString}}}}, {reference_num: {_ilike: $searchInputString}}, {vehicle_make: {_ilike: $searchInputString}}, {vehicle_model: {_ilike: $searchInputString}}, {vehicle_stock: {_ilike: $searchInputString}}, {vehicle_vin: {_ilike: $searchInputString}}, {vehicle_year: {_ilike: $searchInputString}}]}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    active
    cancel_reason
    cancel_requested_at
    cancel_status
    canceled_at
    chargeable
    config
    consumer_at_pickup
    consumer_name
    consumer_phone
    consumer_pickup
    consumer_type
    createdat
    createdBy
    customer_id
    deliver_by
    delivery_arrived
    delivery_started
    delivery_successful
    delivery_time
    driver_id
    driver_name
    lane_id
    lite
    manual_flag
    move_type
    payer_id
    pickup_arrived
    pickup_started
    pickup_successful
    pickup_time
    ready_by
    reference_num
    status
    tags
    updatedat
    usecase_key
    vehicle_color
    vehicle_make
    vehicle_model
    vehicle_stock
    vehicle_vin
    vehicle_year
    customer {
      id
      name
    }
    driver {
      id
      user {
        id
        display_name
        avatar_url
      }
    }
    eventlogs(where: {actiontype_id: {_eq: 1}}) {
      id
      user
    }
    hangtags(order_by: {updated_at: desc}) {
      id
      hash_id
      rear_code
      status
      type
      updated_at
      workflow_data
    }
    lane {
      id
      description
      distance_miles
      duration_sec
      pickup {
        id
        address
        name
      }
      delivery {
        id
        address
        name
      }
    }
    movesByReturnRideId {
      id
      consumer_at_pickup
      consumer_name
      consumer_phone
      consumer_pickup
      consumer_type
    }
    parentMove {
      id
      lite
      status
    }
    scenariotomoves(
      where: {scenario: {status: {_neq: "deprecated"}}}
      order_by: {id: desc}
    ) {
      scenario {
        id
        bundletoscenarios(
          where: {bundle: {status: {_in: ["ready", "dispatching", "dispatched"]}}}
          order_by: {id: desc}
        ) {
          bundle {
            id
            offers(
              where: {status: {_in: ["offered", "accepted", "assigned"]}}
              order_by: {id: desc}
            ) {
              id
              status
              driver {
                id
                user {
                  display_name
                  avatar_url
                }
              }
            }
          }
        }
      }
    }
    workflowset {
      id
      name
    }
  }
}
    `;

/**
 * __useGetMoveSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetMoveSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoveSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoveSearchResultsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      searchInputNumber: // value for 'searchInputNumber'
 *      searchInputString: // value for 'searchInputString'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetMoveSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<GetMoveSearchResultsQuery, GetMoveSearchResultsQueryVariables> & ({ variables: GetMoveSearchResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoveSearchResultsQuery, GetMoveSearchResultsQueryVariables>(GetMoveSearchResultsDocument, options);
      }
export function useGetMoveSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoveSearchResultsQuery, GetMoveSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoveSearchResultsQuery, GetMoveSearchResultsQueryVariables>(GetMoveSearchResultsDocument, options);
        }
// @ts-ignore
export function useGetMoveSearchResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMoveSearchResultsQuery, GetMoveSearchResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoveSearchResultsQuery, GetMoveSearchResultsQueryVariables>;
export function useGetMoveSearchResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoveSearchResultsQuery, GetMoveSearchResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoveSearchResultsQuery | undefined, GetMoveSearchResultsQueryVariables>;
export function useGetMoveSearchResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoveSearchResultsQuery, GetMoveSearchResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMoveSearchResultsQuery, GetMoveSearchResultsQueryVariables>(GetMoveSearchResultsDocument, options);
        }
export type GetMoveSearchResultsQueryHookResult = ReturnType<typeof useGetMoveSearchResultsQuery>;
export type GetMoveSearchResultsLazyQueryHookResult = ReturnType<typeof useGetMoveSearchResultsLazyQuery>;
export type GetMoveSearchResultsSuspenseQueryHookResult = ReturnType<typeof useGetMoveSearchResultsSuspenseQuery>;
export type GetMoveSearchResultsQueryResult = Apollo.QueryResult<GetMoveSearchResultsQuery, GetMoveSearchResultsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/searchResults/queries/getMoveSearchResults.query.gql}
 */
export async function getMoveSearchResults(
  variables: GetMoveSearchResultsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMoveSearchResultsQuery['moves']>
export async function getMoveSearchResults(
  variables: GetMoveSearchResultsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMoveSearchResultsQuery>
export async function getMoveSearchResults(
  variables: GetMoveSearchResultsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMoveSearchResultsQuery['moves'] | GetMoveSearchResultsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMoveSearchResultsQuery>(
    GetMoveSearchResultsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves
}